import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext from '~/context/common/UserContext';
import AvailabilityContext from '~/context/home/AvailabilityContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';
import { fetchSuggestedVehicles } from '~/services/home';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetSuggestedForYou() {
  const {
    suggestedVehicles: { setData, setLoading, setError },
    fetchSuggestedForYouTrigger
  } = useContext(SuggestedForYouContext);
  const {
    suggestedVehicleAvailability: { setData: setAvailabilityData }
  } = useContext(AvailabilityContext);
  const {
    location: {
      data: { zip = '' }
    },
    userState: { isLoaded }
  } = useContext(UserContext);

  useEffectWithController(
    controller => {
      if (!isLoaded || !zip) return;

      setLoading();

      fetchSuggestedVehicles({ zipCode: zip }, controller)
        .then(data => {
          setData(data.vehicles);
          //VehicleInventoryType is the Id in other calls but in this call is the string version
          setAvailabilityData(
            data.vehicles.map(
              ({ vehicleId, locationId, vehicleInventoryTypeId }) => ({
                vehicleId,
                vehicleLocationId: locationId,
                vehicleInventoryType: vehicleInventoryTypeId
              })
            )
          );
        })
        .catch(
          generateErrorLogger(
            'Suggested For You',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      isLoaded,
      setData,
      setLoading,
      zip,
      fetchSuggestedForYouTrigger,
      setError,
      setAvailabilityData
    ]
  );
}
